<div class="nt-wrap">

  <div class="nt-header">
    <div class="nt-header__left">
      <button class="nt-back-btn" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
      <h2 class="nt-header__title">Plantillas</h2>
    </div>
    <button *ngIf="!editing" mat-flat-button color="primary" (click)="newTemplate()">
      <mat-icon>add</mat-icon> Nueva plantilla
    </button>
  </div>

  <div *ngIf="loading" class="nt-state">
    <div class="nt-spinner"></div><span>Cargando...</span>
  </div>
  <div *ngIf="errorMessage" class="nt-error">{{ errorMessage }}</div>

  <!-- Grid de plantillas -->
  <div *ngIf="!editing && !loading" class="nt-grid">

    <div *ngIf="templates.length === 0" class="nt-empty">
      No hay plantillas. Crea la primera.
    </div>

    <div *ngFor="let t of templates" class="nt-card">
      <div class="nt-card__header">
        <h3 class="nt-card__name">{{ t.name }}</h3>
        <span *ngIf="t.isSystem" class="nt-system-badge">Sistema</span>
      </div>
      <p class="nt-card__desc">{{ t.description || 'Sin descripción' }}</p>
      <p class="nt-card__subject"><strong>Asunto:</strong> {{ t.subject }}</p>
      <div class="nt-card__actions">
        <button mat-stroked-button color="primary" (click)="editTemplate(t)">
          <mat-icon>edit</mat-icon> Editar
        </button>
        <button mat-stroked-button color="warn"
                (click)="deleteTemplate(t)"
                [disabled]="t.isSystem"
                [matTooltip]="t.isSystem ? 'No se pueden eliminar plantillas del sistema' : ''">
          <mat-icon>delete</mat-icon> Eliminar
        </button>
      </div>
    </div>
  </div>

  <!-- Editor de plantilla -->
  <div *ngIf="editing" class="nt-editor-grid">

    <div class="nt-panel">
      <h3 class="nt-panel__title">{{ isNew ? 'Nueva plantilla' : 'Editar plantilla' }}</h3>

      <div class="nt-field">
        <label class="nt-label">Nombre *</label>
        <input class="nt-input" type="text" [(ngModel)]="editing.name" />
      </div>
      <div class="nt-field">
        <label class="nt-label">Descripción</label>
        <input class="nt-input" type="text" [(ngModel)]="editing.description" />
      </div>
      <div class="nt-field">
        <label class="nt-label">Asunto *</label>
        <input class="nt-input" type="text" [(ngModel)]="editing.subject" />
      </div>
      <div class="nt-field">
        <label class="nt-label">Contenido HTML *</label>
        <p class="nt-hint">Variables: <code>{{ '{nombre}' }}</code>, <code>{{ '{email}' }}</code></p>
        <quill-editor
          [(ngModel)]="editing.htmlContent"
          [modules]="quillModules"
          [styles]="{ height: '400px' }">
        </quill-editor>
      </div>

      <div class="nt-action-bar">
        <button mat-stroked-button (click)="cancelEdit()">Cancelar</button>
        <button mat-flat-button color="primary" (click)="save()">
          {{ isNew ? 'Crear' : 'Guardar cambios' }}
        </button>
      </div>
    </div>

    <div class="nt-panel nt-panel--preview">
      <h3 class="nt-panel__title">Vista previa</h3>
      <div class="nt-preview-frame" [innerHTML]="editing.htmlContent"></div>
    </div>

  </div>

</div>
